import apiClient from "@/libs/axios";
import router from "@/router";

export const state = {
    data: [],
    total: {
        totalItems: 5,
        totalPages: 5,
    }
};

export const mutations = {
    setData: (state, data) => {
        state.data = data.result.data;
        state.total = {
            totalItems: data.total,
            totalPages: data.last_page,
        };
    },

    updateData: (state, data) => {
        let temp = state.data;
        state.data = temp.map((item) => item.id === data.id ? {...item, is_active: data.is_active} : item)
    },

    deleteItem: (state, id) => {
        let data = state.data;
        state.data = data.filter((item) => item.id !== id)
    },
};

export const actions = {
    async get({ commit }, data) {

        const filters = window.mapFilterData(data);

        await apiClient
            .get(`api/v1/services${filters}`)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('setData', response.data);
                }
            })
            .catch(error => {
                throw error;
            },);

    },
    async toggle({ commit }, data) {
        commit('app/loadingStart', null, {root: true});
        await apiClient
            .post(`api/v1/services/toggle`, data)
            .then(response => {
                console.log(response.data)
                if (response.status === 200) {
                    commit('updateData', response.data.result);
                    commit('app/loadingFinish', null, {root: true});
                }
            })
            .catch(error => {
                throw error;
            },);
        commit('app/loadingFinish', null, {root: true});

    },
    async create({ commit }, data) {
        await apiClient
            .post(`api/v1/services/create`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then(response => {
                console.log(response.data)
                if (response.status === 201) {
                    commit('updateData', response.data);
                    router.push({name: 'services'})
                }
            })
            .catch(error => {
                throw error;
            },);

    },
};

export const getters = {
    getData(state) {
        return state.data;
    },
    getTotal(state) {
        return state.total;
    },
};
